var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTopBackgroundAdmin(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1440,
    height: 250,
    viewBox: "0 0 1440 250",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_494_10)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 250,
    fill: "#010101"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-117.386 848.975C-29.0133 944.582 96.9766 1020.3 223.442 1068.35C332.672 1109.84 455.49 1130.56 574.395 1108.63C666.918 1091.56 754.286 1060.34 839.751 1026.95C896.19 1004.95 952.893 983.344 1008.94 960.509C1062.68 938.51 1115.47 908.372 1173.2 894.358C1270.7 870.688 1375.48 884.965 1471.92 857.862C1549.45 836.083 1609.04 791.58 1640.1 728.069C1718.9 567.279 1668.73 332.42 1482.07 234.349C1310.45 144.153 1100.61 114.433 900.842 135.772C822.938 144.087 749.977 165.316 673.289 177.724C562.975 195.543 451.551 193.013 341.052 177.944C231.452 162.984 108.925 137.972 3.31687 179.153C-91.5059 216.133 -147.125 296.671 -187.703 373.425C-272.031 532.939 -244.274 711.702 -117.386 848.975Z",
    fill: "#01BF71"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-116.386 858.141C-28.0133 953.748 97.9766 1029.47 224.442 1077.51C333.672 1119 456.49 1139.73 575.395 1117.79C667.918 1100.72 755.286 1069.51 840.751 1036.11C897.19 1014.11 953.893 992.51 1009.94 969.675C1063.68 947.677 1116.47 917.538 1174.2 903.525C1271.7 879.854 1376.48 894.131 1472.92 867.029C1550.45 845.25 1610.04 800.746 1641.1 737.236C1719.9 576.446 1669.73 341.586 1483.07 243.515C1311.45 153.32 1101.61 123.599 901.842 144.938C823.938 153.254 750.977 174.483 674.289 186.89C563.975 204.709 452.551 202.179 342.052 187.11C232.452 172.151 109.925 147.138 4.31687 188.32C-90.5059 225.3 -146.125 305.838 -186.703 382.592C-271.031 542.106 -243.274 720.868 -116.386 858.141Z",
    fill: "#F9F9F9"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_494_10"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 250,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTopBackgroundAdmin);
export default __webpack_public_path__ + "static/media/top-background-admin.99fca9c18b86b62bb1e9e2f63219e5a8.svg";
export { ForwardRef as ReactComponent };